import { Icon } from '@chakra-ui/react'
const NetworkIcon = () => {
    return (
        <>
            <Icon width="18" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 20H20V0" fill="#CCF0F7" />
            </Icon>
        </>
    )
}
export default NetworkIcon
